import "./PrivateRound.module.css";
import MainNavigation from "@/reusable_sections/Header";
import InvestmentTiers from "./sections/InvestmentTiers";
import WhitelistingInquiry from "./sections/WhitelistingInquiry";
import FooterEssentials from "@/reusable_sections/Footer";
export default function PrivateRoundPage() {
  return <div>
      <MainNavigation />
      <InvestmentTiers />
      <WhitelistingInquiry />
      <FooterEssentials />
    </div>;
}